<template>
    <div class="erm_wrapper">

        <AppTable :tableData="reservations" v-loading="loading">
            <template #header>
                <h1 class="table-title">All Reservation Table</h1>
            </template>

            <template #filter>
                <el-input class="easyRestaurantManager-search-input erm_input" v-model="search" style="width: 240px" size="large"
                    placeholder="Please Input" prefix-icon="Search" />
            </template>

            <template #columns>
                <el-table-column prop="id" label="ID" width="60" />
                <el-table-column prop="table_number" label="Table" width="auto" />
                <el-table-column prop="customer_name" label="Name" width="auto" />
                <el-table-column prop="phone" label="Phone" width="auto" />
                <el-table-column prop="email" label="Email" width="auto" />
                <el-table-column prop="reservation_date" label="Date" width="auto" />
                <el-table-column prop="reservation_time" label="Time" width="auto" />
                <el-table-column prop="num_guests" label="Person" width="auto" />

                <el-table-column prop="status" label="Status" width="auto">
                    <template #default="{ row }">
                        <el-tag :type="row.status === 'confirmed' ? 'success' : row.status === 'cancelled' ? 'danger' : 'warning'">
                            {{ row.status }}
                        </el-tag>
                    </template>
                </el-table-column>

                <el-table-column label="Operations" width="120">
                    <template #default="{ row }"
                        style="display: flex; justify-content: center; align-items: center; gap: 20px;">
                        <el-tooltip class="box-item" effect="dark" content="Click to edit status" placement="top-start">

                            <el-dropdown trigger="click">
                                <span class="el-dropdown-link">
                                    <Icon icon="easyRestaurantManager-edit" />
                                </span>

                                <template #dropdown>
                                    <el-dropdown-menu>
                                        <el-dropdown-item
                                            @click="updateStatus(row.id, 'pending')">Pending</el-dropdown-item>
                                        <el-dropdown-item
                                            @click="updateStatus(row.id, 'confirmed')">Confirmed</el-dropdown-item>
                                        <el-dropdown-item
                                            @click="updateStatus(row.id, 'cancelled')">Cancelled</el-dropdown-item>
                                    </el-dropdown-menu>
                                </template>
                            </el-dropdown>
                        </el-tooltip>

                        <el-tooltip class="box-item" effect="dark" content="Click to delete reservations"
                            placement="top-start">
                            <el-button @click="openDeleteReservationModal(row)" class="erm_box_icon" link size="small">
                                <Icon icon="easyRestaurantManager-delete" />
                            </el-button>
                        </el-tooltip>
                    </template>
                </el-table-column>
            </template>

            <template #footer>
                <el-pagination v-model:current-page="currentPage" v-model:page-size="pageSize"
                    :page-sizes="[10, 20, 30, 40]" large :disabled="total_reservation <= pageSize" background
                    layout="total, sizes, prev, pager, next" :total="+total_reservation" />
            </template>

        </AppTable>



        <AppModal :title="'Delete Reservation Table'" :width="500" :showFooter="false" ref="delete_reservation_modal">
            <template #body>

                <div class="delete-modal-body">
                    <h1>Are you sure ?</h1>
                    <p>You want to delete this reservation table</p>
                </div>
            </template>
            <template #footer>
                <div class="easyRestaurantManager-modal-footer">
                    <el-button @click="$refs.delete_reservation_modal.handleClose()" type="default"
                        size="medium">Cancel</el-button>
                    <el-button @click="deleteReservation" type="primary" size="medium">Delete</el-button>
                </div>
            </template>
        </AppModal>

    </div>
</template>

<script>
import axios from 'axios';
import AppTable from "../../components/AppTable.vue";
import Icon from "../../components/Icons/AppIcon.vue";
import AppModal from "../../components/AppModal.vue";
export default {
    components: {
        AppTable,
        Icon,
        AppModal,
    },
    data() {
        return {
            search: '',
            reservations: [],
            reservation: {},
            total_reservation: 0,
            loading: false,
            add_reservation_modal: false,
            currentPage: 1,
            pageSize: 10,
            active_id: null,
            rest_api: window.RestaurantMenuMangeData.rest_api,
            nonce: window.RestaurantMenuMangeData.nonce
        }
    },
    methods: {
        formatAddedDate(date) {
            if (!date) return '';
            const options = { day: 'numeric', month: 'long', year: 'numeric' };
            return new Date(date).toLocaleDateString('en-GB', options);
        },
        async getReservation() {
            this.loading = true;
            try {
                const response = await axios.get(`${this.rest_api}/getReservation`, {
                    headers: {
                        'X-WP-Nonce': this.nonce
                    },
                });
                this.reservations = response.data?.reservations;
                this.loading = false;
            } catch (error) {
                this.loading = false;
                console.error('Error fetching couriers:',);
            }
        },

        async updateStatus(id, status) {
            try {
                const response = await axios.post(`${this.rest_api}/updateReservationStatus`, {
                    id: id,
                    status: status
                }, {
                    headers: {
                        'X-WP-Nonce': this.nonce
                    }
                });
                this.$message.success("Status updated successfully!");
                this.getReservation();
            } catch (error) {
                console.error("Error updating status:", error);
                this.$message.error("Failed to update status");
            }
        },

        openDeleteReservationModal(row) {
            this.active_id = row.id;
            this.$refs.delete_reservation_modal.openModel();
        },
        async deleteReservation() {
            try {
                const response = await axios.post(`${this.rest_api}/deleteReservation`, { id: this.active_id }, {
                    headers: {
                        'X-WP-Nonce': this.nonce
                    }
                });
                this.getReservation();
                this.$refs.delete_reservation_modal.handleClose();
            } catch (error) {
                console.error('Error fetching couriers:',);
            }
        },


    },
    mounted() {

        this.getReservation();

    }


}
</script>

<style lang="scss">
.el-dropdown-link {
    margin-right: 12px;
    margin-top: 4px;
    cursor: pointer;
}
</style>